import React from "react";

export default function SameSurfaceBooking({
  otherSurface,
  selectedOtherSurface,
  setSelectedOtherSurface,
}) {
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-12 mt-3">
          Please choose from the available options below for the selected date
          and time!
        </div>
        <div className="col-12 mt-2">
          <select
            className="form-select"
            value={selectedOtherSurface}
            onChange={(e) => {
              setSelectedOtherSurface(e.target.value);
            }}
          >
            {otherSurface?.map((surface) => (
              <option value={surface?.id}>{surface?.courtName}</option>
            ))}
          </select>
        </div>
      </div>
    </React.Fragment>
  );
}
